// extracted by mini-css-extract-plugin
module.exports = {"toggle":"Toggle_toggle__2Q5_3","toggle__switch":"Toggle_toggle__switch__1DDfW","toggle__checkbox":"Toggle_toggle__checkbox__1p49F"};